// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"TableAndSearch_scrollContainer__3C0kZ","scrollHidden":"TableAndSearch_scrollHidden__1IN39","tabContent":"TableAndSearch_tabContent__3Y9h6"};